import { ITypedArrayObject } from '../../types/mappers/array';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { EStatus } from '../../types/likes';
import { IQuestion } from '../../types/questions/questions';

export enum EQuestionsActionTypes {
  SetQuestions = 'QUESTIONS/SET_QUESTIONS',
  SetLoading = 'QUESTIONS/SET_LOADING',
  SetAnswersVisibility = 'QUESTIONS/SET_ANSWERS_VISIBILITY',
  AddAnswersToQuestion = 'QUESTIONS/ADD_ANSWERS_TO_QUESTION',
  SetAnswersPage = 'QUESTIONS/SET_ANSWERS_PAGE',
  SetQuestionReaction = 'QUESTIONS/SET_QUESTION_REACTION',
  SetQuestionsPage = 'QUESTIONS/SET_QUESTION_PAGE',
}

export interface ISetQuestionsPayload extends ITypedArrayObject<IQuestion, string> {
  hasMore: boolean;
  page: number;
}
export type TSetQuestions = ITypedReduxAction<EQuestionsActionTypes.SetQuestions, ISetQuestionsPayload>;
export type TSetQuestionsPagination = ITypedReduxAction<EQuestionsActionTypes.SetQuestionsPage, ISetQuestionsPayload>;

export interface ISetAnswersVisibilityPayload {
  questionId: string;
  state: boolean;
}
export type TSetAnswersVisibility = ITypedReduxAction<
  EQuestionsActionTypes.SetAnswersVisibility,
  ISetAnswersVisibilityPayload
>;

export interface IAddAnswersToQuestionPayload {
  questionId: string;
  answerIds: string[];
  hasMore: boolean;
  answersPage: number;
}
export type TAddAnswersToQuestion = ITypedReduxAction<
  EQuestionsActionTypes.AddAnswersToQuestion,
  IAddAnswersToQuestionPayload
>;

export interface ISetAnswersPagePayload {
  questionId: string;
  page: number;
}
export type TSetAnswersPage = ITypedReduxAction<EQuestionsActionTypes.SetAnswersPage, ISetAnswersPagePayload>;

export type TSetLoading = ITypedReduxAction<EQuestionsActionTypes.SetLoading, boolean>;

export type TSetQuestionReactionPayload = {
  questionId: string;
  type: EStatus;
};
export type TSetQuestionReaction = ITypedReduxAction<
  EQuestionsActionTypes.SetQuestionReaction,
  TSetQuestionReactionPayload
>;

export type TQuestionsActions =
  | TSetQuestions
  | TSetAnswersVisibility
  | TAddAnswersToQuestion
  | TSetAnswersPage
  | TSetLoading
  | TSetQuestionReaction
  | TSetQuestionsPagination;
